export type NodeServiceMessageHandler<TMessage> = (message: TMessage) => void;

/** Owns action-specific callbacks for messages received from node-service. */
export class NodeServiceMessageHandlers<TMessage extends { header: { action: string } }> {
  private readonly handlers = new Map<string, Array<NodeServiceMessageHandler<TMessage>>>();

  public dispatch(message: TMessage): void {
    const handlers = this.handlers.get(message.header.action);
    if (!handlers?.length) {
      console.log(`[Node Service Client] No handlers registered for action: ${message.header.action}`);
      return;
    }
    handlers.forEach(handler => {
      try {
        handler(message);
      } catch (error) {
        console.error(`[Node Service Client] Error in message handler for ${message.header.action}:`, error);
      }
    });
  }

  public add(action: string, handler: NodeServiceMessageHandler<TMessage>): void {
    const handlers = this.handlers.get(action) ?? [];
    handlers.push(handler);
    this.handlers.set(action, handlers);
  }

  public remove(action: string, handler: NodeServiceMessageHandler<TMessage>): boolean {
    const handlers = this.handlers.get(action);
    if (!handlers) return false;
    const index = handlers.indexOf(handler);
    if (index < 0) return false;
    handlers.splice(index, 1);
    return true;
  }

  public clear(action?: string): void {
    if (action) this.handlers.delete(action);
    else this.handlers.clear();
  }
}
